module.exports = __webpack_public_path__ + "static/media/mb_dark_favicon.c1e8c817.png";